// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../types/schema';

import { TrusteeFragment } from '../../../trustees/graphql/trustees.fragments.generated';
import { gql } from '@apollo/client';
import { TrusteeFragmentDoc } from '../../../trustees/graphql/trustees.fragments.generated';
export type TrustTrusteesList_SuccessorTrusteeFragment = (
  { __typename?: 'Trustee', id: string, level?: Types.TrusteeLevel | null, notes?: string | null, duties?: Array<{ __typename?: 'TrusteeDuty', id: string, kind: Types.TrusteeDutyKind }> | null }
  & TrusteeFragment
);

export type TrustTrusteesList_TrusteeFragment = (
  { __typename?: 'Trustee', id: string, level?: Types.TrusteeLevel | null, notes?: string | null, duties?: Array<{ __typename?: 'TrusteeDuty', id: string, kind: Types.TrusteeDutyKind }> | null }
  & TrusteeFragment
);

export const Operations = {
  Fragment: {
    TrustTrusteesList_SuccessorTrustee: 'TrustTrusteesList_SuccessorTrustee' as const,
    TrustTrusteesList_Trustee: 'TrustTrusteesList_Trustee' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}

export const TrustTrusteesList_SuccessorTrusteeFragmentDoc = gql`
    fragment TrustTrusteesList_SuccessorTrustee on Trustee {
  id
  level
  notes
  duties {
    id
    kind
  }
  ...Trustee
}
    ${TrusteeFragmentDoc}`;
export const TrustTrusteesList_TrusteeFragmentDoc = gql`
    fragment TrustTrusteesList_Trustee on Trustee {
  id
  level
  notes
  duties {
    id
    kind
  }
  ...Trustee
}
    ${TrusteeFragmentDoc}`;